import type { ListPluginElement, ListPluginPropertyOptions } from '../types';
import styled from 'styled-components';
import { LIST_VARIANTS } from '../constants';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';

type ListEditableProps = {
  pluginOptions: ListPluginPropertyOptions;
  element: ListPluginElement;
  children: React.ReactNode;
} & ComponentPropsWithoutRef<'ol'>;

export const ListEditable = forwardRef<HTMLOListElement | HTMLUListElement, ListEditableProps>(
  ({ pluginOptions: _pluginOptions, element, children, ...attributes }, ref) => {
    if (element.variant === LIST_VARIANTS.ol) {
      return (
        <OrderedListComponent ref={ref as React.Ref<HTMLOListElement>} {...attributes}>
          {children}
        </OrderedListComponent>
      );
    } else if (element.variant === LIST_VARIANTS.ul) {
      return (
        <UnorderedListComponent ref={ref as React.Ref<HTMLUListElement>} {...attributes}>
          {children}
        </UnorderedListComponent>
      );
    } else {
      return null;
    }
  }
);

ListEditable.displayName = 'ListEditable';

const OrderedListComponent = styled.ol`
  margin: 0;
`;

export const OrderedListRenderer = OrderedListComponent;

const UnorderedListComponent = styled.ul`
  margin: 0;
`;

export const UnorderedListRenderer = UnorderedListComponent;
